import Carousel from "../components/carousel"


function Main() {
    return(
        <div>
            <div>
                <h1>Welcome</h1>
                    <p>
                        Restoring an old home isn't for the faint of heart, but it is absolutely worth it. Join us as we
                        fumble through projects to make this Edwardian-era Colonial Revival even more grand. 
                    </p>
            </div>
            <div>
                <Carousel />
            </div>
        </div>
    )
}

export default Main
